// Story 7.6 — system_silence card. The server composes the copy
// ("Quiet week from X" title + days-silent body, feed.rs); this card
// renders it as the dashed ghost card (Epic 8 feed-page template) — a
// deliberately NOT-parchment quiet panel on the dark wire ground. System
// voice — no honesty-seal footer; the copy itself is the honesty.

import { publicProfileUrl } from "./feedCardShared";
import type { FeedCard } from "./useFeed";

export function SilenceCard({ card }: { card: FeedCard }) {
  return (
    <div
      className="rounded-lg border border-dashed border-brand-gold-500/30 bg-brand-forest-900/40 px-6 py-6 text-center [overflow-wrap:anywhere]"
      data-testid="feed-silence"
    >
      <p className="m-0 font-heading text-base italic text-brand-paper-100/80">
        {card.title}
      </p>
      {card.body ? (
        <p className="m-0 mt-2 font-body text-sm italic text-brand-paper-100/60">
          {card.body}
        </p>
      ) : null}
      {card.creator_handle ? (
        <p className="m-0 mt-3">
          <a
            href={publicProfileUrl(card.creator_handle)}
            target="_blank"
            rel="noopener noreferrer"
            className="font-body text-sm not-italic text-brand-gold-300 hover:brightness-110"
            data-testid="silence-profile-link"
          >
            Visit @{card.creator_handle}&apos;s profile →
          </a>
        </p>
      ) : null}
    </div>
  );
}
